<template>
  <div>
    <component :is="currentTab" />
  </div>
</template>

<script>
import SalesTable from "./modules/SalesTable.vue";
import ManualSalesTable from "./modules/ManualSalesTable.vue";
import UpgradeSubscription from "./modules/UpgradeSubscription.vue";

export default {
   props: ['currentTabProp'],
  components: { SalesTable, ManualSalesTable, UpgradeSubscription },
  data() {
    return {
     
    };
  },
  computed: {
    currentTab() {
      let screen = "";
      switch (this.currentTabProp) {
        case "default":
          screen = "sales-table";
          break;
        case "manual":
          screen = "manual-sales-table";
          break;
        default:
          screen = "sales-table";
          break;
      }
      return screen;
    },
  },
};
</script>

<style lang="scss" scoped></style>
